export default {
    name: 'Header',
    created() {
        this.$nextTick(function () {
            // 使用下拉菜单
            this._$.Select2('.select2')
            this.getRiclist()
        
             
        })
    },
    mounted() {
        this.$nextTick(function () {
            $(".languagebox .box").click(function () {
                $('.landetailbox').removeClass('d-none');
            });
            $(".backbtn").click(function () {
                $(this).parent().addClass('d-none');
            });
            $(".h-dropdown-wrap > a").click(function () {
                $(this).parent().toggleClass('dshow');

                $("body").removeClass('megashow');
                $("body").removeClass('menushow');
                $("body").removeClass('searchopen');
                if ($(".menuparent").hasClass('submenumenushow') || $(".h-dropdown-wrap").hasClass('dshow') || $("body").hasClass('lngncnboxopen')) {
                    $(".hoverlay").addClass('show');
                } else {
                    $(".hoverlay").removeClass('show');
                }
                $('.menuparent').removeClass('submenumenushow')
                $("body").removeClass('lngncnboxopen');
            });
            $('.togglemenu').click(function () {
                $('body').toggleClass('menushow');
                $('body').removeClass('searchopen');
                $('.h-dropdown-wrap').removeClass('dshow');
            });
            $(document).on('click', (e) => {
                this.removeClass()
            });
        })
    },
    data() {
        return {
            NavData: this.$router.options.routes.filter((_, index) => index > 3),// 路由数组
            Language: localStorage.getItem('Language') || 2,// 选定语言
            LANGUAGE1: process.env.VUE_APP_LANGUAGE1, // 选择语言按钮的显示
            LANGUAGE2: process.env.VUE_APP_LANGUAGE2, // 选择语言按钮的显示
            NavActive: null,
            SearchValue: '', // 全网搜查的文字
            Login: [],
            ricData: []

        }
    },
    computed: {

    },
    watch: {

    },
    methods: {

        /* 获取ric list */
        getRiclist: function () {
            const _this = this
            $.ajax({
                type: 'GET',
                url: process.env.VUE_APP_API + 'GetRICList',
                data: { token: 'webkey' },
                dataType: 'json',
                success: (data) => {
                    if (data.status === 'SUCCESS') {
                        this.ricData = data.ric
                    }
                },
                error: function (error) {
                    console.log(error)
                }
            })
        },
        removeClass: function () {
            $("body").removeClass('megashow');
            $(".hoverlay").removeClass('show');
            $('.menuparent').removeClass('submenumenushow')
            $(".h-dropdown-wrap").removeClass('dshow')
        },
        MenuparentCilck: function (e, box) {
            e.preventDefault();
            e.stopPropagation();
            let $parent = box == 'svg' ? $(e.target).parent().parent() : $(e.target).parent();
            $parent.toggleClass('submenumenushow')
                .siblings('.menuparent').removeClass('submenumenushow');
            if ($(window).width() > 767) {
                if ($parent.hasClass('submenumenushow') || $(".h-dropdown-wrap").hasClass('dshow') || $("body").hasClass('lngncnboxopen')) {
                    jQuery("body").addClass('megashow')
                    $(".hoverlay").addClass('show');
                } else {
                    jQuery("body").removeClass('megashow')
                    $(".hoverlay").removeClass('show');
                }
                $(".h-dropdown-wrap").removeClass('dshow')
                $("body").removeClass('lngncnboxopen');
            }
        },
        // 打开全网搜索框
        Search: function () {
            $("body").toggleClass('searchopen');
            $("body").removeClass('megashow');
            $("body").removeClass('lngncnboxopen');
            $(".h-dropdown-wrap").removeClass('dshow');
            $(".hoverlay").toggleClass('show');
        },
        // 打开语言选择框
        Lngncnbox: function () {
            $("body").toggleClass('lngncnboxopen');
            $("body").toggleClass('megashow');
            $("body").removeClass('searchopen');

            if ($(".menuparent").hasClass('submenumenushow') || $(".h-dropdown-wrap").hasClass('dshow') || $("body").hasClass('lngncnboxopen')) {
                $(".hoverlay").addClass('show');
            } else {
                $(".hoverlay").removeClass('show');
            }
            $(".h-dropdown-wrap").removeClass('dshow');
            $('.menuparent').removeClass('submenumenushow')
        },

        // 转换语言
        LanguageClick: function () {
            this.$i18n.locale = this.Language == 1 ? 'en' : 'id';
            localStorage.setItem('Language', this.Language)
            this.$router.go(0)
        },
        // 手机打开语言转换
        MlngToggle: function () {
            jQuery(".mega_mlngdropdown").addClass('show');
        },
        // 返回上一页
        Megaback: function () {
            jQuery('.megaback').parent().parent().removeClass('show');
            jQuery('.megaback').parent().parent().removeClass('active');
            jQuery('.megaheader ul li > a').removeClass('active');
        },
        // 跳到全网页搜查的页面
        GetSearch: function () {
            localStorage.setItem('searchText', this.SearchValue)
            window.location.href = '/cgsi/SearchResult'
        }
    }
}
